import kformUtils from '../utils/kform-utils';

const kformFormController = /* @ngInject */ (/** @type {any} */ $scope) => {
	$scope.options = $scope.options || {};
	$scope.alerts = [];
	$scope.iframeReady = false;
	$scope.formName = $scope.name || 'kformForm';
	// Shows the given alerts (single or array), and dismisses old alerts
	$scope.showAlerts = (/** @type {{ message: string; }} */ alerts) => {
		/* eslint-disable no-empty */
		try {
			alerts.message = (JSON.parse(alerts.message)).data;
		}
		catch {}
		/* eslint-enable no-empty */

		$scope.alerts = [alerts].flat();
	};

	// Create the formio object.
	// $scope.formio = KformScope.register($scope);
	$scope.formio = {};

	$scope.isVisible = (
		/** @type {any} */ component,
		/** @type {any} */ row,
	) => {
		if (
			$scope.readOnly && component.input
			&& $scope.submission
			&& kformUtils.isEmpty($scope.submission.data[component.key])
		) {
			return false;
		}
		return kformUtils.isVisible(
			component,
			row,
			$scope.submission ? $scope.submission.data : null,
			$scope.hideComponents,
			$scope.form,
		);
	};

	$scope.isDisabled = (
		/** @type {any} */ component,
	) => $scope.readOnly || component.disabled || (Array.isArray($scope.disableComponents)
		&& $scope.disableComponents.includes(component.key));

	$scope.isRequired = (/** @type {any} */ component) => kformUtils.isRequired(component, $scope.requireComponents);
};

export default kformFormController;
